const STORAGE_KEY = 'docConfirmationListFilters';

export const DOC_CONFIRMATION_STATUS_FILTER = {
  PENDING: 'pending',
  ALL: 'all',
  CONFIRMED: 'confirmed',
};

const STATUS_VALUES = Object.values(DOC_CONFIRMATION_STATUS_FILTER);

const isValidDateInput = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);

export const loadDocConfirmationListFilters = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!isValidDateInput(data?.dateFrom)) return null;
    const dateTo = isValidDateInput(data?.dateTo) ? data.dateTo : data.dateFrom;
    return {
      dateFrom: data.dateFrom,
      dateTo,
      statusFilter: STATUS_VALUES.includes(data?.statusFilter)
        ? data.statusFilter
        : DOC_CONFIRMATION_STATUS_FILTER.PENDING,
    };
  } catch {
    return null;
  }
};

export const saveDocConfirmationListFilters = ({ dateFrom, dateTo, statusFilter }) => {
  if (!isValidDateInput(dateFrom)) return;
  const to = isValidDateInput(dateTo) ? dateTo : dateFrom;
  const filter = STATUS_VALUES.includes(statusFilter)
    ? statusFilter
    : DOC_CONFIRMATION_STATUS_FILTER.PENDING;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        dateFrom,
        dateTo: to,
        statusFilter: filter,
      })
    );
  } catch {
    /* ignore */
  }
};
